import { withHistory } from "../../../../../common/util/withHistory";
import { mapFromApiZone, zoneDimensionsValid } from "../../helpers";
import { ApiZone } from "../../types";
import { CurrentAction, PageSaveState, State } from "../state";

export interface ResetZonesAction {
  page: number;
  type: "RESET ZONES";
  zones: Array<ApiZone>;
}

export const resetZones = (state: State, action: ResetZonesAction): State => {
  const zones = action.zones
    .map(mapFromApiZone(state.pages[action.page].dimensions))
    .filter(zoneDimensionsValid(state.pages[action.page].dimensions, state.taxonomy));
  return {
    ...state,
    pages: [
      ...state.pages.slice(0, action.page),
      {
        ...state.pages[action.page],
        activeZones: [],
        currentAction: CurrentAction.HOVERING_NOTHING,
        firstDragEvent: false,
        hoveredZone: -1,
        index: action.page,
        pageSaveState: PageSaveState.Dirty,
        previousMouseLocation: null,
        selection: null,
        zoneHistory: withHistory(zones),
        zones,
      },
      ...state.pages.slice(action.page + 1),
    ],
  };
};
